export function getTenderState(data, rfq = false) {
  const now = new Date();

  const tenderStart = new Date(data.tenderStartDateTime);
  const tenderClose = new Date(data.tenderCloseDateTime);
  const bidStart = new Date(data.bidStartDateTime);
  const bidClose = new Date(data.bidCloseDateTime);
  const auctionStart = new Date(data.auctionStartDateTime);
  const auctionClose = new Date(data.auctionCloseDateTime);

  let statusList = [];

  if (rfq) {
   

    if (now < tenderStart) {
      statusList.push("upcoming");
    }

    if (now >= tenderStart && now < bidStart) {
      statusList.push("cb_upcoming");
    }

    if (now >= bidStart && now < bidClose) {
      statusList.push("cb_ongoing");
    }

    if (now >= bidClose && now < tenderClose) {
      statusList.push("tender_closing_soon");
    }

    if (now >= tenderClose) {
      statusList.push("cb_ongoing");
      statusList.push("ra_ongoing");
      statusList.push("tender_closing_soon");
      statusList.push("closed");
    }

    return statusList;
  }

  if (now < tenderStart) {
    statusList.push("upcoming");
  }

  if (now >= tenderStart && now < bidStart) {
    statusList.push("cb_upcoming");
  }

  if (now >= bidStart && now < bidClose) {
    statusList.push("cb_ongoing");
  }

  if (now >= bidClose && now < auctionStart) {
    statusList.push("ra_upcoming");
  }

  if (now >= auctionStart && now < auctionClose) {
    statusList.push("cb_ongoing");
    statusList.push("ra_ongoing");
  }

  if (now >= auctionClose && now < tenderClose) {
    statusList.push("cb_ongoing");
    statusList.push("ra_ongoing");
    statusList.push("tender_closing_soon");
  }

  if (now >= tenderClose) {
    statusList.push("cb_ongoing");
    statusList.push("ra_ongoing");
    statusList.push("tender_closing_soon");
    statusList.push("closed");
  }

  return statusList;
}
